/**
 * Tabs Component - UI Layer
 * Tab navigation with active state. Each tab optionally has a `helpKey` that
 * renders a small HelpButton next to the label, which opens HelpDrawer without
 * triggering the tab change.
 */

import { HelpButton } from '@/features/help';
import styles from './Tabs.module.css';

interface Tab {
  key: string;
  label: string;
  /** Si está presente, renderiza un `?` junto al label que abre el HelpDrawer con este pageKey. */
  helpKey?: string;
}

interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onChange: (key: string) => void;
  className?: string;
}

export function Tabs({ tabs, activeTab, onChange, className = '' }: TabsProps) {
  return (
    <div className={`${styles.wrapper} ${className}`} role="tablist">
      {tabs.map((tab) => {
        const isActive = activeTab === tab.key;
        return (
          <div
            key={tab.key}
            className={`${styles.tab} ${isActive ? styles.active : ''} flex items-center`}
          >
            <button
              role="tab"
              type="button"
              aria-selected={isActive}
              className="bg-transparent border-0 p-0 cursor-pointer"
              style={{ font: 'inherit', color: 'inherit' }}
              onClick={() => onChange(tab.key)}
            >
              {tab.label}
            </button>
            {tab.helpKey && <HelpButton pageKey={tab.helpKey} />}
          </div>
        );
      })}
    </div>
  );
}
